import React from "react";
import PopupCard from "../../../../Auth/PopupCard";

const ApplyAssignForm = ({
  onOpen,
  onClose,
  handleProceed,
  selectedRole,
  selectedRows = [],
  isLoading = false,
}) => {
  if (!onOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40">
      <PopupCard
        type="success"
        title={`You are about to assign this form to the selected user. This action will consume ${selectedRows.length} license from your available ${selectedRole} licenses.`}
        message="Do you want to proceed?"
        onConfirm={handleProceed}
        onCancel={onClose}
        confirmText={"Okay"}
        cancelText="Cancel"
        widthClass="sm:w-[480px]"
        confirmDisabled={isLoading}
        cancelDisabled={isLoading}
      />
    </div>
  );
};

export default ApplyAssignForm;
